import RytmWebflow from 'rytm-webflow';
import { Offcanvas } from 'bootstrap';
import imagesLoaded from 'imagesloaded';

import { scrollToTargetForce, scrollBackABit } from '../scrolling';
import { classNames, OBJECT_SCROLL_DISTANCE } from '../constants';
import { initCarousel } from '../shared/carousel';

class ChapterObjectsController extends RytmWebflow.Controller {
  
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e);
    this.scrollToRequestedObject();
  }
  addEventListeners() {
    super.addEventListeners();
    document.documentElement.addEventListener('click', this.onDocumentClick);
    document.documentElement.addEventListener('keydown', this.onKeyDown);
    window.addEventListener('resize', this.onWindowResize);
  }
  removeEventListeners() {
    super.removeEventListeners();
    document.documentElement.removeEventListener('click', this.onDocumentClick);
    document.documentElement.removeEventListener('keydown', this.onKeyDown);
    window.removeEventListener('resize', this.onWindowResize);
  }
  // ### Custom
  onDocumentClick = (e) => {
    const link = e.target.closest('a');
    if (link && link.dataset.galleryLoader) {
      e.preventDefault();
      this.loadGallery(link);
    }
  }
  loadGallery = (link) => {
    if (link.classList.contains('gallery-loading')) {
      return;
    }
    const url = link.dataset.galleryLoader;
    const wrapperSelector = link.dataset.galleryWrapper;
    const canvasSelector = link.getAttribute('href');
    if (!url || !wrapperSelector || !canvasSelector) {
      console.error('Missing artobject gallery data attributes');
      return;
    }
    document.documentElement.classList.add(classNames.OBJECT_GALLERY_LOADING);
    link.classList.add('gallery-loading');
    fetch(url)
      .then(response => response.text())
      .then(html => {
        const wrapper = document.querySelector(wrapperSelector);
        wrapper.innerHTML = html;
        // init tiny slider carousel
        const carousel = wrapper.querySelector('.r-carousel');
        if (carousel) {
          initCarousel(carousel);
        }
        // wait for images inside wrapper to load
        const imgLoad = imagesLoaded(wrapper, () => {
          const offcanvas = new Offcanvas(canvasSelector);
          offcanvas.show();
          this.onGalleryLoadComplete(link);
        });

      })
      .catch(error => {
        console.error('Error:', error);
        this.onGalleryLoadComplete(link);
      });
  }
  onGalleryLoadComplete = (link) => {
    document.documentElement.classList.remove(classNames.OBJECT_GALLERY_LOADING);
    link.classList.remove('gallery-loading');
  }

  // # Check and scroll to requested object
  scrollToRequestedObject = () => {
    const requestedObjectSelector = this.getRequestedObjectSelector();
    if (!requestedObjectSelector) {
      return false;
    }
    const requestedObject = document.querySelector(requestedObjectSelector);
    if (requestedObject) {
      // wait for the objects to init
      clearTimeout(this.scrollTimeout);
      this.scrollTimeout = setTimeout(() => {
        scrollToTargetForce(requestedObject, {duration: 2, offset: 10});
      }, 500);
    }
  }
  getRequestedObjectSelector = () => {
    const container = document.querySelector(this.getContainerSelector());
    return container ? container.dataset.requestedObject : null;
  }
  
  //  ## Event handlers ###
  onWindowResize = (e) => {
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => {
      this.view.updateContainerHeight();
    }, 200);
      
  }
  onKeyDown = (e) => {
    const disabledClassList = [
      'object-gallery-open',
      'case-study-open',
    ];
    const isDisabled = disabledClassList.some((className) => document.documentElement.classList.contains(className));
    if (isDisabled) {
      return;
    }
    switch (e.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        this.nextObject(e);
        break;
      case 'ArrowLeft':
      case 'ArrowUp':
        this.previousObject(e);
        break;
      default:
        break;
    }
  }
  nextObject = (e) => {
    const el = this.getNextObject();
    if (el) {
      e.preventDefault();
      // console.log("nextObject", el);
      scrollToTargetForce(el, {duration: .5});
    }
  }
  previousObject = (e) => {
    const el = this.getPreviousObject();
    if (el) {
      e.preventDefault();
      // console.log("previousObject", el);
      scrollBackABit(OBJECT_SCROLL_DISTANCE, {duration: .5});
    }
  }
  getNextObject = () => {
    const container = document.querySelector(this.getContainerSelector());
    return container.querySelector(`.${classNames.OBJECT}.${classNames.OBJECT_ACTIVE} + .${classNames.OBJECT}`);
  }
  getPreviousObject = () => {
    const container = document.querySelector(this.getContainerSelector());
    let result = null;
    const list = [...container.querySelectorAll(`.${classNames.OBJECT}`)];
    let prevEl = null;
    list.forEach((el, index) => {
      el.classList.add('my-el-' + index);
      if (el.classList.contains(classNames.OBJECT_ACTIVE)) {
        // console.log("### found active on index", index);
        // console.log("### prevEl", prevEl);
        result = prevEl;
        return result;
      }
      prevEl = el;
    });
    return result;
    // return container.querySelector(`.${classNames.OBJECT}.${classNames.OBJECT_ACTIVE} ~ .${classNames.OBJECT}`);
  }
  getOpenedObject = () => {
    const container = document.querySelector(this.getContainerSelector());
    return container.querySelector(`.${classNames.OBJECT}.${classNames.OBJECT_ACTIVE}`);
  }

}

export default ChapterObjectsController;